export const hasOrganizationLinkedInCompany = (
	organization,
	fallbackValue = null
) => {
	if (typeof organization?.has_linkedin_company === 'boolean') {
		return organization.has_linkedin_company
	}

	return Boolean(organization?.linkedin_id || fallbackValue)
}

export const formatLinkedInCompanyUrl = value => {
	if (!value) return ''
	const trimmed = String(value).trim()

	if (trimmed.startsWith('http://')) {
		return trimmed
			.replace('http://', 'https://')
			.replace('linkedin.com', 'www.linkedin.com')
	}

	if (trimmed.startsWith('https://')) {
		if (!trimmed.includes('www.linkedin.com')) {
			return trimmed.replace('linkedin.com', 'www.linkedin.com')
		}
		return trimmed
	}

	if (trimmed.startsWith('www.')) {
		return `https://${trimmed}`
	}

	return `https://www.linkedin.com/company/${trimmed}`
}

export const extractLinkedInCompanyId = value => {
	if (!value) return null

	const trimmed = String(value).trim()
	const patterns = [
		/^https?:\/\/(?:www\.)?linkedin\.com\/company\/([a-zA-Z0-9\-_]+)(?:\/admin\/dashboard)?\/?$/i,
		/^www\.linkedin\.com\/company\/([a-zA-Z0-9\-_]+)(?:\/admin\/dashboard)?\/?$/i,
		/^linkedin\.com\/company\/([a-zA-Z0-9\-_]+)(?:\/admin\/dashboard)?\/?$/i,
		/^([a-zA-Z0-9\-_]+)$/i
	]

	for (const pattern of patterns) {
		const match = trimmed.match(pattern)
		if (match) {
			return match[1]
		}
	}

	return null
}

export const isValidLinkedInCompanyValue = value =>
	!value || !String(value).trim() || Boolean(extractLinkedInCompanyId(value))
